var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6467 2.7489C17.9717 2.7489 18.2362 3.01345 18.2362 3.33843V18.6615C18.2362 18.9865 17.9717 19.2511 17.6467 19.2511H4.35988C4.03489 19.2511 3.77035 18.9865 3.77035 18.6615V3.33843C3.77035 3.01345 4.03489 2.7489 4.35988 2.7489H17.6467ZM17.6467 1.57141H4.35988C3.38413 1.57141 2.59286 2.36269 2.59286 3.33843V18.6615C2.59286 19.6373 3.38413 20.4286 4.35988 20.4286H17.6467C18.6224 20.4286 19.4137 19.6373 19.4137 18.6615V3.33843C19.4137 2.36269 18.6224 1.57141 17.6467 1.57141Z",
    fill: "#1B1B1F",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01783 5.05521C5.76192 5.05521 5.52642 5.15961 5.35843 5.3276C5.18966 5.49638 5.08525 5.72795 5.08525 5.98386C5.08525 6.49881 5.50209 6.91565 6.01704 6.91565C6.27295 6.91565 6.50845 6.81124 6.67644 6.64325C6.84443 6.47526 6.94883 6.24291 6.94883 5.98386C6.94883 5.72795 6.84443 5.49638 6.67644 5.3276C6.50845 5.15961 6.27295 5.05521 6.01783 5.05521Z",
    fill: "#1B1B1F",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0721 6.83479H9.08017C8.61153 6.83479 8.23081 6.45485 8.23081 5.98542C8.23081 5.51678 8.61074 5.13606 9.08017 5.13606H16.0713C16.54 5.13606 16.9207 5.51599 16.9207 5.98542C16.9215 6.45485 16.5408 6.83479 16.0721 6.83479Z",
    fill: "#1B1B1F",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01783 10.0697C5.76192 10.0697 5.52642 10.1741 5.35843 10.3421C5.19044 10.5101 5.08604 10.7424 5.08604 10.9983C5.08604 11.5133 5.50287 11.9301 6.01783 11.9301C6.27373 11.9301 6.50923 11.8257 6.67722 11.6577C6.84521 11.4897 6.94962 11.2574 6.94962 10.9983C6.94962 10.7424 6.84521 10.5108 6.67722 10.3421C6.50845 10.1741 6.27295 10.0697 6.01783 10.0697Z",
    fill: "#1B1B1F",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0721 11.8493H9.08019C8.61155 11.8493 8.23082 11.4693 8.23082 10.9999C8.23082 10.5313 8.61076 10.1505 9.08019 10.1505H16.0714C16.54 10.1505 16.9207 10.5305 16.9207 10.9999C16.9215 11.4685 16.5408 11.8493 16.0721 11.8493Z",
    fill: "#1B1B1F",
    fillOpacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01783 15.0843C5.76192 15.0843 5.52642 15.1887 5.35843 15.3567C5.19044 15.5247 5.08604 15.757 5.08604 16.0129C5.08604 16.5279 5.50287 16.9447 6.01783 16.9447C6.27373 16.9447 6.50923 16.8403 6.67722 16.6723C6.84521 16.5043 6.94962 16.272 6.94962 16.0129C6.94962 15.757 6.84521 15.5254 6.67722 15.3567C6.50845 15.1887 6.27295 15.0843 6.01783 15.0843Z",
    fill: "#1B1B1F",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0721 16.8639H9.08019C8.61155 16.8639 8.23082 16.4839 8.23082 16.0145C8.23082 15.5459 8.61076 15.1651 9.08019 15.1651H16.0714C16.54 15.1651 16.9207 15.5451 16.9207 16.0145C16.9215 16.4831 16.5408 16.8639 16.0721 16.8639Z",
    fill: "#1B1B1F",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogs);
export default __webpack_public_path__ + "static/media/icon-logs.8d2c37afa23997d9b86274131f87639b.svg";
export { ForwardRef as ReactComponent };